import React, { FC } from 'react';
import cls from 'classnames';

import { ToggleProps } from './Toggle.types';

const Toggle: FC<ToggleProps> = (props) => {
	const {
		checked,
		children,
		className,
		defaultChecked,
		describedby,
		isEnabled = true,
		labelledby,
		onChange,
	} = props;

	return (
		<label className={cls('toggle', className)}>
			<input
				type="checkbox"
				aria-labelledby={labelledby}
				aria-describedby={describedby}
				checked={checked}
				defaultChecked={defaultChecked}
				disabled={!isEnabled}
				onChange={onChange}
			/>
			{children}
		</label>
	);
};

Toggle.displayName = 'Toggle';

export default Toggle;
